
import { mapState, mapActions } from 'vuex';
import AppAiIcon from '@/components/core/AppAiIcon';
import AiIconType from '@/enums/AiIconType';

export default {
  i18nComponentKey: 'WidgetAddOnSizeRecommendation.components.SizeRecommendationPc',
  name: 'SizeRecommendationPc',
  components: { AppAiIcon },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    isGradientAiIconType() {
      return this.reviewSettings.ai_icon_type === AiIconType.GRADIENT;
    }
  },
  mounted() {
    this.$emit('ready');
  },
  methods: {
    ...mapActions('dialog', ['openSizeRecommendationPopup']),
    onClick() {
      this.openSizeRecommendationPopup();
    }
  }
};
